import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {compose, lifecycle} from 'recompose';

import {setWrappedDisplayName} from '@ciscospark/react-component-utils';

import {
  checkCurrentCalls,
  checkWebRTCSupport,
  listenForCalls,
  registerClient
} from './actions';


export default compose(
  setWrappedDisplayName('WithMedia'),
  connect(
    (state) => ({
      sparkInstance: state.spark.get('spark'),
      media: state.media
    }),
    (dispatch) => bindActionCreators({
      checkCurrentCalls,
      checkWebRTCSupport,
      listenForCalls,
      registerClient
    }, dispatch)
  ),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        media,
        sparkInstance
      } = nextProps;

      if (sparkInstance) {
        if (!media.webRTC.hasCheckedSupport) {
          nextProps.checkWebRTCSupport(sparkInstance);
        }
        else if (!media.status.isRegistered && !media.status.isRegistering) {
          nextProps.registerClient(sparkInstance);
        }
        else if (!media.status.isListening) {
          // Check if there are any existing calls and store them
          nextProps.checkCurrentCalls(sparkInstance);
          // Listen for new calls
          nextProps.listenForCalls(sparkInstance);
        }
      }
    }
  })
);
